module.exports = __webpack_public_path__ + "img/promo.5727e5e9.svg";